import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface BulkAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'danger' | 'default';
  testId?: string;
}

interface BulkActionBarProps {
  selectedCount: number;
  actions: BulkAction[];
  onClear: () => void;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({ selectedCount, actions, onClear }) => {
  if (selectedCount === 0) return null;

  const variantClasses = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    default: 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50',
  };

  return (
    <div
      data-testid="bulk-action-bar"
      className="bg-primary-50 border border-primary-200 rounded-lg px-4 py-3 flex items-center justify-between"
    >
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-primary-800">
          {selectedCount} selected
        </span>
        <button
          data-testid="bulk-clear"
          onClick={onClear}
          className="text-primary-600 hover:text-primary-800"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
      <div className="flex items-center gap-2">
        {actions.map(action => (
          <button
            key={action.label}
            data-testid={action.testId || `bulk-${action.label.toLowerCase().replace(/\s+/g, '-')}`}
            onClick={action.onClick}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium ${variantClasses[action.variant || 'default']}`}
          >
            {action.icon}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BulkActionBar;
